/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { UpdateForm } from 'framework/form';
import useJournalEntryService from 'domain/finance/journalEntry/useJournalEntryService';
import { useJournalEntryUrl } from 'domain/finance/journalEntry/shared/useJournalEntryRouting';
import UpdateLedgerBreadcrumbs from 'domain/finance/journalEntry/createupdate/Update/Breadcrumbs';
import JournalEntryForm from 'domain/finance/journalEntry/createupdate/JournalEntryForm';

const UpdateLedgerPage = () => {
  const { getById, getValidationSchema, update } = useJournalEntryService();
  const { getListUrl } = useJournalEntryUrl();

  return (
    <UpdateForm
      submitFormFunc={update}
      getDataFunc={getById}
      afterSubmit={{
        redirect: getListUrl(),
        message: 'You are awesome! The Journal Entry has been successfully updated.',
      }}
      getValidationSchemaFunc={getValidationSchema}
      initialData={{
        totals: 0,
        transfers: [{}, {}],
      }}
    >
      <CreatePageLayout breadcrumbs={<UpdateLedgerBreadcrumbs />} title="Edit: Journal Entry">
        <JournalEntryForm />
      </CreatePageLayout>
    </UpdateForm>
  );
};

export default UpdateLedgerPage;
